// Import utilities
const {
	isDefined,
	isEmpty
} = _uo.utility;

import ConditionsGroup from '@builder/item/conditions/conditions-group';
import { updateRemoteConditionsMeta } from '@builder/item/conditions/utilities';
import Actions from '@builder/item/actions';

/**
 * Parses the conditions saved in the recipe meta and saves sanitazed data in the Uncanny Automator object
 *
 * @param {Object} recipe The recipe data, unsanitazed
 * @return {undefined}
 */
const parseConditionsInMeta = ( recipe ) => {
	// Create the empty object
	UncannyAutomator.recipe.conditions = {};

	// Check if the recipe object has conditions
	if ( ! isDefined( recipe.actions_conditions ) ) {
		return;
	}
	
	// Check if it's empty
	if ( isEmpty( recipe.actions_conditions ) ) {
		return;
	}

	// Check if the conditions blocks are outdated and don't include the ID
	let conditionsAreOutdated = false;

	// Try to parse it
	try {
		// Parse conditions
		const conditionsInMeta = JSON.parse( recipe.actions_conditions );

		// Create the conditions group
		conditionsInMeta.forEach( ( group ) => {
			// Check if the group ID is defined
			// If it's not, then this conditions block is outdated and we have to update it
			conditionsAreOutdated = conditionsAreOutdated || isEmpty( group.id );

			// Make sure it has conditions before adding it
			// We don't render conditions blocks without conditions
			if ( isEmpty( group.conditions ) ) {
				return;
			}

			// Add it to the main object
			const conditionsGroup = new ConditionsGroup( { id: group.id } );

			// Add the priority
			conditionsGroup.priority = group.priority;

			// Add the mode
			conditionsGroup.mode = group.mode;

			// Add the actions
			conditionsGroup.actions = group.actions;

			// Add the conditions
			conditionsGroup.conditions = group.conditions;
		} );
	} catch ( e ) {
		// Continue regardless of error

		// Output error if the developer mode is enabled
		if ( UncannyAutomator.dev.developerMode ) {
			// eslint-disable-next-line no-console
			console.error(
				// eslint-disable-next-line max-len
				"Conditions: Automator failed to parse the conditions saved in the meta. Make sure you're saving a valid JSON."
			);
		}
	}

	// Check if the conditions blocks are outdated and don't include the ID
	if ( conditionsAreOutdated ) {
		updateRemoteConditionsMeta( {
			onSuccess: () => {
				new Actions();
			}
		} );
	}
};

export default parseConditionsInMeta;
